import { selectAllNodes, selectNode } from './helpers';

function fetchProductsData(categoryId, taxName) {
  return jQuery.ajax({
    url: window.sharedResources.ajaxurl,
    type: 'POST',
    data: {
      action: 'fetch-product-data',
      data: {
        category_id: categoryId,
        taxonomy_name: taxName
      }
    }
  });
}

function createCardNode(cardObj) {
  const a = document.createElement('a');
  const divImage = document.createElement('div');
  const divImageSpan = document.createElement('span');
  const h4Title = document.createElement('h4');
  const spanPrice = document.createElement('span');

  a.href = cardObj.link;
  a.classList.add('selected-products__item');
  a.classList.add('category-card');
  a.dataset.color = cardObj.pa_color
    ? cardObj.pa_color.join(',')
    : cardObj.pa_color;
  a.dataset.type = cardObj['pa_flower-type']
    ? cardObj['pa_flower-type'].join(',')
    : cardObj['pa_flower-type'];

  divImage.style.backgroundImage = `url(${cardObj.image})`;
  divImage.classList.add('selected-products__item-image');

  divImageSpan.classList.add('selected-products__item-readmore');
  divImageSpan.innerText = 'Se och köp';

  h4Title.innerText = cardObj.title;
  h4Title.classList.add('selected-products__item-title');

  spanPrice.classList.add('selected-products__item-price');
  spanPrice.innerHTML = `${cardObj.price} ${cardObj.currency}`;

    a.appendChild(divImage)
    a.appendChild(h4Title)
    a.appendChild(spanPrice)
    a.appendChild(divImageSpan)

  return a;
}

// lazy load on window scroll with intersection observer
function productsInfiniteScroll(productsList, blockNode) {
  return function scrollFunctionality(entries, observer) {
    const container = selectNode('single-category__grid', blockNode);
    const preloader = selectNode('single-category__preloader', blockNode);
    const productsCards = selectAllNodes('category-card', blockNode);

    if (productsCards.length < 28) return;
    entries.map(entry => {
      if (entry.target === preloader && entry.isIntersecting) {
        preloader.classList.add('show-preloader');

        const productsToLoad = productsList.slice(
          productsCards.length,
          productsCards.length + 28
        );

        if (productsToLoad.length) {
          const fragment = document.createDocumentFragment();

          productsToLoad.map(el => fragment.appendChild(el.node));

          window.setTimeout(() => {
            preloader.classList.remove('show-preloader');
            container.appendChild(fragment);
          }, 300);
        } else {
          observer.unobserve(entry.target);
          preloader.classList.remove('show-preloader');
        }
      }
    });
  };
}

async function categoryPageFunctionality(blockNode) {
  const gridContainer = selectNode('single-category__grid', blockNode);
  const categoryId = gridContainer.dataset.catid;
  const taxName = gridContainer.dataset.taxname;
  const filterNodes = selectAllNodes(
    'single-category__filter-value',
    blockNode
  );
  const filterInputs = selectAllNodes(
    'single-category__filter-input',
    blockNode
  );
  const noProducts = '<div class="no-products">Inga produkter hittades</div>';
  const preloader = selectNode('single-category__preloader', blockNode);

  let filterCriteria = {};
  let filterCriteriaKeys = [];
  let isFiltering = false;

  const hideGrid = () => gridContainer.classList.add('hidden');
  const showGrid = () => gridContainer.classList.remove('hidden');
  const hideFilters = (force = false) => {
    if (force || isFiltering) {
      filterNodes.map(filter => filter.classList.remove('show-dropdown'));
      isFiltering = false;
    }
  };
  const toggleDropdowns = filter => e => {
    isFiltering = !isFiltering;
    if (!filter.classList.contains('show-dropdown')) hideFilters(true);
    filter.classList.toggle('show-dropdown');
  };

  //fetch all products data
  const allProductsRaw = await fetchProductsData(categoryId, taxName);
  if (!allProductsRaw.length) return;

  const allProducts = allProductsRaw.map(el => {
    return { ...el, node: createCardNode(el) };
  });

  // Lazy load functionality when user scroll down
  const observer = new IntersectionObserver(
    productsInfiniteScroll(allProducts, blockNode),
    {
      root: null,
      rootMargin: '0px',
      threshold: 0.5 // height of the bottom part of viewport when new products will be attached to DOM
    }
  );
  observer.observe(preloader);

  // reduce all product list to array of DOM nodes according to filter criteria
  const reduceProducts = (res, product) => {
    const isInclude = filterCriteriaKeys.every(key => {
      const filterValue = filterCriteria[key];
      if (filterValue === 'all') return true;

      if (key === 'flower-price') {
        const [min, max] = filterValue.split(',');
        const price = parseInt(product.price, 10);
        return parseInt(min, 10) <= price && parseInt(max, 10) >= price;
      } else {
        return product[key] && product[key].includes(filterValue);
      }
    });

    return isInclude ? [...res, product] : res;
  };

  //filter products array and append it to DOM
  const filterData = e => {
    //disconnect lazy load
    observer.unobserve(preloader);
    hideFilters(true);

    const { type, name } = e.target.dataset;
    const filterLabel = blockNode.querySelector(
      `.${type} .filter-value-result`
    );

    hideGrid();

    filterLabel.innerHTML = name;
    filterCriteria[type] = e.target.value;
    const filteredNodeList = allProducts.reduce(reduceProducts, []);
    const fragment = document.createDocumentFragment();

    filteredNodeList.map(el => {
      fragment.appendChild(createCardNode(el));
    });
    gridContainer.innerHTML = '';

    if (filteredNodeList.length) {
      gridContainer.appendChild(fragment);
    } else {
      gridContainer.innerHTML = noProducts;
    }

    window.setTimeout(showGrid, 300);
  };

  // bind filtering on filters change
  filterInputs.map(el => {
    // get data for the filter object
    if (el.checked) {
      filterCriteria[el.dataset.type] = el.value;
      filterCriteriaKeys = [...filterCriteriaKeys, el.dataset.type];
    }

    el.addEventListener('change', filterData);
  });

  // bind animation for the filters
  filterNodes.map(el => el.addEventListener('click', toggleDropdowns(el)));

  // hide filters on scroll
  // window.addEventListener('scroll', hideFilters, { passive: true });
}

// init category grid scripts
export default function initCategoryGrid() {
  const categoryNodes = selectAllNodes('category-block');

  if (categoryNodes.length) categoryNodes.map(categoryPageFunctionality);
}
